// ToDo: change the name of this guard to AuthenticationGuard

import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  NavigationExtras
} from '@angular/router';

import { AuthenticationService } from '../services';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.authService.isAuthenticated().map((authenticated) => {
      if (authenticated) {
        return true;
      }

      this.authService.redirectUrl = state.url;

      // Set our navigation extras object
      // that contains our global query params and fragment
      const navigationExtras: NavigationExtras = {
        queryParams: {},
        fragment: ''
      };

      // Navigate to the login page with extras
      this.router.navigate(['/login'], navigationExtras);
      return false;
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/guards/authentication-guard.service.ts